<template>
    <div>
        <!-- Affichage de la sécurisation -->
        <div v-if="c_order && c_order.fingerprints?.length > 0" class="px-2">
            <h3 class="h6 block-title border-bottom ps-0 mt-4 mb-3">
                <i class="text-primary fa fa-fw fa-money-bill-wave text-muted me-1"></i>
                {{ $t('checkout.security.title') }}
            </h3>
            <table class="table table-striped table-vcenter table-bordered" style="width: 100%; text-align: center">
                <thead>
                    <tr>
                        <th>{{ $t('checkout.security.date') }}</th>
                        <th>{{ $t('checkout.security.type') }}</th>
                        <th>{{ $t('checkout.security.amount') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in c_order.fingerprints" :key="index">
                        <td>{{ parseDate(item.updated_at, 'lll') }}</td>
                        <td>
                            <span class="badge bg-primary rounded-pill" v-if="item.stripe_id">stripe</span>
                            <span class="badge bg-primary rounded-pill" v-if="item.voucher_id">{{
                                $t('checkout.security.voucher')
                            }}</span>
                            <span class="badge bg-primary rounded-pill" v-if="item.serie_user_id">{{
                                $t('checkout.security.subscription')
                            }}</span>
                            <span class="badge bg-primary rounded-pill" v-if="item.treatment_user_id">{{
                                $t('checkout.security.package')
                            }}</span>
                            <br />
                            <span v-if="item.voucher_id">( {{ item.voucherCode }} )</span>
                        </td>
                        <td>{{ parseFloat(item.amount).toFixed(2) }}{{ $symbolCurrency }}</td>
                        <td v-if="item.amount > 0">
                            <FingerprintChange :item="item"></FingerprintChange>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import { get } from 'vuex-pathify'
import PaymentRefound from './PaymentRefound.vue'
import FingerprintChange from './FingerprintChange.vue'
import axios from 'axios'

export default {
    components: { PaymentRefound, FingerprintChange },
    props: ['orderObj'],
    data: () => ({
        invoices: [],
    }),
    created() {},
    computed: {
        ...get('overlay@data', {
            c_order: 'order',
        }),
    },
    methods: {
        getVoucherCode(id) {
            return axios.get(`/back-office/caisse/getVoucherCode/${id}`).then((res) => res.data)
        },
        stringify(val) {
            return JSON.stringify(val)
        },
        parseDate(date, format) {
            return moment(date).locale('fr').format(format)
        },
    },
    watch: {
        c_remainPrice(val) {
            if (this.closeSale && val !== '0.00') {
                this.closeSale = false
            }
        },
        usedFidelityPoints(newVal) {
            this.$emit('used-fidelity-points', newVal)
        },

        async 'c_order.invoices'(val) {
            if (!val) return

            const copy = []
            for (let i = 0; i < val?.length; i++) {
                const elem = val[i]
                if (elem.voucher_id) elem.voucher = await this.getVoucherCode(elem.voucher_id)
                copy.push(elem)
            }
            this.invoices = copy.reverse()
        },
    },
}
</script>

<style scoped>
.disable-focus:focus {
    border-color: none !important;
    box-shadow: none !important;
}
.theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: transparent !important;
}
</style>
<style scoped>
#promo-code-select {
    margin: 15px 0px;
    width: 100%;
}
select#promo-code-select {
    height: 40px;
    font-size: clamp(12px, 0.729545vw, 16px);
    padding-top: 9px;
    border-radius: 7px;
}
.btn-dark-appli {
    font-size: 16px !important;
    padding-left: 26px !important;
    padding-right: 26px !important;
    height: 38px !important;
    line-height: 24px !important;
    border-radius: 8px !important;
    font-weight: 500 !important;
}
.btn-green-appli {
    color: #fff !important;
    background: #46d5b3;
    font-size: 16px !important;
    padding-left: 26px !important;
    padding-right: 26px !important;
    height: 38px !important;
    line-height: 24px !important;
    border-radius: 8px !important;
    font-weight: 500 !important;
    border: solid 1px #46d5b3;
}
.form-control,
.form-select {
    border-radius: 8px;
    height: 40px;
    /*padding-top: 8px;*/
    font-size: clamp(12px, 0.729545vw, 16px);
}
.rest-du {
    background: #7d2dbd;
    border-radius: 4px;
    padding: 5px 12px;
    height: 32px !important;
}
.box-amount {
    font-weight: 400px;
    font-size: 12px;
    padding: 2px 17px;
    border-radius: 4px;
    background: #46d5b3;
    color: white;
}
.some-amount {
    border: solid 1px #7b8289;
    border-radius: 8px;
    padding: 4px 8px;
    width: 80%;
}
.title-some-am {
    border-bottom: solid 1px #7d2dbd;
}
#toggleButton {
    cursor: pointer;
    transition: transform 0.3s;
}
.disable-focus:focus {
    border-color: none !important;
    box-shadow: none !important;
}
</style>
